module.exports = __webpack_public_path__ + "static/media/hall-P6.f6432660.svg";